import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BreadcrumbService } from '../../../domain/services/breadcrumb/breadcrumb.service';
import { FeesService } from '../../../domain/services/fees/fees.service';
import { FeeModel } from '../../../domain/models/fee.model';

@Component({
  selector: 'app-fees',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    RouterModule,
  ],
  templateUrl: './fees.component.html',
  styleUrl: './fees.component.css',
})
export class FeesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable) table!: MatTable<FeeModel>;

  // Fee and Allowance now live on separate pages, driven by route data.
  feeType: 'Fee' | 'Allowance' = 'Fee';
  displayedColumns = ['name', 'term', 'rate', 'source', 'effectiveFrom', 'effectiveTo'];
  dataSource = new MatTableDataSource<FeeModel>([]);
  searchTerm = '';
  totalCount = 0;

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly feesService: FeesService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  get pageLabel(): string {
    return this.feeType === 'Allowance' ? 'Allowances' : 'Fees';
  }

  private get baseRoute(): string {
    return this.feeType === 'Allowance' ? 'admin/allowances' : 'admin/fees';
  }

  ngOnInit(): void {
    this.feeType = this.route.snapshot.data['feeType'] === 'Allowance' ? 'Allowance' : 'Fee';

    this.breadcrumbService.updateBreadcrumbs([
      { icon: 'account_balance', url: `/app/${this.baseRoute}`, label: 'Administrative' },
      { icon: 'tune', url: `/app/${this.baseRoute}`, label: this.pageLabel },
    ]);

    this.feesService.getFees().subscribe((fees) => {
      const scoped = fees.filter((f) => f.type === this.feeType);
      this.dataSource.data = scoped;
      this.totalCount = scoped.length;
      this.dataSource.filterPredicate = (data: FeeModel, filter: string) =>
        data.name.toLowerCase().includes(filter.toLowerCase());
    });
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onSearch(): void {
    this.dataSource.filter = this.searchTerm.trim();
  }

  onRowClick(fee: FeeModel): void {
    this.router.navigate(['/app/admin/fees', fee.id]);
  }

  goBack(): void {
    window.history.back();
  }
}
